module.exports = __webpack_public_path__ + "static/media/system smart final icon.25fab2af.svg";